import { useAppKitNetwork } from '@reown/appkit/react'
import type { SupportedChainId } from 'config/chains'
import { networks } from 'config/chains'
import { useCallback } from 'react'
import { useConnection, useSwitchChain } from 'wagmi'

export default function useSelectChain() {
  const { switchNetwork } = useAppKitNetwork()
  const { isDisconnected } = useConnection()
  const { switchChain, switchChainAsync } = useSwitchChain()
  return useCallback(
    async (targetChain: SupportedChainId): Promise<boolean> => {
      const network = networks.find((network) => network.id === targetChain)
      if (!network) {
        throw new Error(`Network with chainId ${targetChain} not found`)
      }
      if (isDisconnected) {
        switchNetwork(network)
        switchChain({ chainId: targetChain })
        return true
      }
      try {
        await switchChainAsync({ chainId: targetChain })
        return true
      } catch {
        return false
      }
    },
    [switchNetwork, switchChain, switchChainAsync, isDisconnected]
  )
}
